/** DVA namespace — must match `model.js` and route registration. */
export const MODEL_NAME = 'extraUserFields';

/** API route prefix — shared by `model.js` (createCrudModel) and list descriptor routes. */
export const FETCH_ROUTE = 'userExtraField';

/** Singular entity name for `createCrudModel` reducers/notifications. */
export const ENTITY_NAME = 'extraUserField';

/** CoreQueries key for paged/detail OData shapes. */
export const FETCH_PARAMS = 'UserExtraField';

/** i18n resource key for form drawer hero summary (`configForm.hero.summary.resource.{key}.*`). */
export const FORM_RESOURCE_KEY = 'extraUserFields';

/** Default list sort. */
export const DEFAULT_ORDER_BY = 'order asc';
